import { useEffect, useState } from "react";
import { getCustomisationValue } from "../../../EditablePreview/EditablePreview";
import ModuleNumericalInput from "../../components/ModuleNumericalInput";
import { changeNumericalFieldValue } from "../../ModuleList";
import { renderFirstCustomBlock, renderSecondCustomBlock } from "../../customFields/CustomFieldRenderer";

const AppearanceModule = (props) => {
    const moduleConfig = props.moduleConfig;
    const customisationVars = props.customisationVars;

    let opacityFieldConfig = null;
    let cornerRadiusFieldConfig = null;
    for (let i = 0; i < moduleConfig.fields.length; i++) {
        const field = moduleConfig.fields[i];
        if (field.field.includes('appearance-opacity')) {
            opacityFieldConfig = field;
        } else if (field.field.includes('appearance-corner-radius')) {
            cornerRadiusFieldConfig = field;
        }
    }

    const [opacity, setOpacity] = useState(getCustomisationValue(customisationVars, opacityFieldConfig?.dataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode) ?? '100');
    const [cornerRadius, setCornerRadius] = useState(getCustomisationValue(customisationVars, cornerRadiusFieldConfig?.dataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode) ?? '0');
    useEffect(() => {
        if (opacityFieldConfig?.dataLink) {
            const opacityValue = getCustomisationValue(customisationVars, opacityFieldConfig.dataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode);
            setOpacity(opacityValue ?? '100');
        } else {
            setOpacity('100');
        }
        if (cornerRadiusFieldConfig?.dataLink) {
            const cornerRadiusValue = getCustomisationValue(customisationVars, cornerRadiusFieldConfig.dataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode);
            setCornerRadius(cornerRadiusValue ?? '0');
        } else {
            setCornerRadius('0');
        }
    }, [moduleConfig, customisationVars, opacityFieldConfig, cornerRadiusFieldConfig, props.forceUpdate]);

    const changeOpacityFieldValue = (value) => {
        if (opacityFieldConfig) {
            if (changeNumericalFieldValue(customisationVars, opacityFieldConfig, value, true, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode)) {
                setOpacity(value);
                props?.forceUpdateComponent?.();
            }
        }
    }

    const changeCornerRadiusFieldValue = (value) => {
        if (cornerRadiusFieldConfig) {
            if (changeNumericalFieldValue(customisationVars, cornerRadiusFieldConfig, value, true, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode)) {
                setCornerRadius(value);
                props?.forceUpdateComponent?.();
            }
        }
    }

    return (
        <div className="v2-basic-module-holder">
            <h5>Appearance</h5>

            {renderFirstCustomBlock(props)}

            <div className='v2-module-columns-holder'>
                <div className='v2-module-one-column'>
                    <div className={`v2-module-field-label${!!opacityFieldConfig?.dataLink ? '' : ' disabled'}`}>Opacity</div>
                    <ModuleNumericalInput
                        fieldLabel={<div className="v2-module-block-field-input-label" style={{opacity: opacity / 100}} />}
                        value={opacity}
                        fieldId={'opacity'}
                        enabled={!!opacityFieldConfig?.dataLink}
                        onChange={(fieldId, value) => changeOpacityFieldValue(value)}
                        hiddenDropDown={true}
                        hiddenDropDownOptions={[0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100]}
                    />
                </div>

                <div className='v2-module-one-column'>
                    <div className={`v2-module-field-label${!!cornerRadiusFieldConfig?.dataLink ? '' : ' disabled'}`}>Corner Radius</div>
                    <ModuleNumericalInput
                        fieldLabel={<div className="v2-module-block-field-input-label" style={{borderTopLeftRadius: cornerRadius / 2}} />}
                        value={cornerRadius}
                        fieldId={'corner-radius'}
                        enabled={!!cornerRadiusFieldConfig?.dataLink}
                        onChange={(fieldId, value) => changeCornerRadiusFieldValue(value)}
                        hiddenDropDown={true}
                        hiddenDropDownOptions={[0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100]}
                    />
                </div>
            </div>

            {renderSecondCustomBlock(props)}
            
        </div>
    );
}

export default AppearanceModule;
